import useReadOnlyModeGuard from "@rf-hooks/useReadOnlyModeGuard";

const useApproveDocument = () => {
  const { guardReadOnlyAction } = useReadOnlyModeGuard();

  const handleApproveDocument = async (documentId: number) => {
    guardReadOnlyAction("aprobar documento", "property-validation-documents");
  };

  return {
    handleApproveDocument
  };
};

export default useApproveDocument;
